export default {
  pages: state => state.pages,
  activePages: state => state.activePages,
  currentPage: state => state.currentPage,
  defaultPage: state => state.defaultPage,
  loading: state => state.loading
}
